import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

export default function Forbidden() {
  return (
    <Box flex="1" borderRadius="8" bg="gray.800" p="8">
      <VStack spacing="6" align="start">
        <Heading size="lg" color="pink.400">
          Acesso negado
        </Heading>
        <Text color="gray.200">
          Você não possui permissão para acessar esta funcionalidade. Se acredita que isso é um erro, contate o
          administrador do sistema.
        </Text>
        <Button as={Link} to="/dashboard" colorScheme="pink">
          Voltar para o início
        </Button>
      </VStack>
    </Box>
  )
}
